// extracted by mini-css-extract-plugin
export default {"def":"_type-module__def__v8Dzq"};